import { DayHours } from '../../types'

export interface DayProps {
  /** The number of days to show after */
  plusDays: number
  startHour: DayHours
  endHour: DayHours
}

export const DEFAULT_DAY_OPTIONS: DayProps = {
  plusDays: 0,
  startHour: 9,
  endHour: 17,
}
